import CloseIcon from 'public/icons/ag-icons/Close.svg';

interface CustomOverlayProps {
  onClose: () => void;
  children: React.ReactNode;
  isDesktopSize?: boolean;
  parentClassName?: string;
}

export default function CustomOverlay({ onClose, children, isDesktopSize, parentClassName }: CustomOverlayProps) {
  return (
    <div className={parentClassName}>
      <button onClick={onClose} className={`${isDesktopSize ? 'p-12' : 'p-6'} absolute right-2 top-2`}>
        <CloseIcon />
      </button>
      {children}
    </div>
  );
}
